/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ../locale-data/index.js (ignored)
// module id = 485
// module chunks = 0